import { AbilityRole } from "./abilitiesByRole"
import store from "./store"
import { KeyDict } from "./types"
import { Feature, hasFeature } from './featureFlags/featureFlags'

//Multiple function signatures & return types for different parameters
function roleNames (role: string): string;
function roleNames (): KeyDict<string>;

//Function implementation
function roleNames (role: string = ''): string|KeyDict<string> {
  const isSelfServe = hasFeature(Feature.SELF_SERVE)
  const defaultNames: KeyDict<string> = {
    [AbilityRole.Admin]: 'Admin',
    [AbilityRole.Member]: 'Crew Member',
    [AbilityRole.GuestCaster]: 'Guest Commentator',
    //Add remaining defaults if self serve isn't active
    ...!isSelfServe ? {
      [AbilityRole.Caster]: 'Guest Caster',
      [AbilityRole.SuperUser]: 'Superuser',
      [AbilityRole.AudioEngineer]: 'Audio Engineer',
      [AbilityRole.CrewObserver]: 'Crew Observer'
    } : {}
  }

  if (role === AbilityRole.SuperUser) {
    return defaultNames[role]
  }
  // We don't want to include superuser when the whole list is requrested, but we still want
  // to have the benefit of a TS Record to ensure that all other AbilityRoles are included.
  const names:KeyDict<string> = { ...defaultNames }
  if (!isSelfServe) delete names[AbilityRole.SuperUser]

  for (const [id, role] of Object.entries(store.state.abilities.teamRoles)) {
    names[id] = role.name
  }

  if (!role) return names
  if (role in names) return names[role]
  return 'Unknown Role'
}

export default roleNames

export const roleDescription = (role: AbilityRole): string => {
  const description: Record<AbilityRole, string> = {
    [AbilityRole.Admin]: 'Has all permissions within this team.',
    [AbilityRole.Member]: 'Has all permissions on events and casts. Limited member management options.',
    [AbilityRole.Caster]: 'Has limited permissions within the cast he is invited to.',
    [AbilityRole.GuestCaster]: 'Has only Cast viewing permissions and can connect microphone/webcam to casts.',
    [AbilityRole.SuperUser]: 'Superuser',
    [AbilityRole.AudioEngineer]: 'Has viewing permissions on casts and full permissions on audio.',
    [AbilityRole.CrewObserver]: 'Restricted to all viewing permissions on events and casts.'
  }
  return description[role]
}
